export const KEYS = {
    ENTER: 13,
    ESC: 27,
}
